import { ComponentProps, forwardRef } from "react";

export const AvatarFemale = forwardRef<
  SVGSVGElement,
  Pick<ComponentProps<"svg">, "width" | "height">
>(function AvatarFemale({ width = "90%", height = "90%" }, ref) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 106 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46777 107.978C7.41699 106.801 11.5713 105.775 15.6689 104.764C21.9072 103.224 28.0127 101.717 33.0566 99.7538V87.4901C21.9141 86.9589 8.04395 86.0878 0.303711 76.8436C8.79199 73.6366 12.7041 63.5702 13.2461 48.5233C13.376 44.9003 13.2217 42.0839 13.083 39.5546C12.7949 34.2792 12.5762 30.2597 15.1445 22.7968C22.6787 0.937389 50.5322 -6.53722 66.0498 6.2538C78.2178 4.95692 90.4756 11.2479 93.124 30.0624C93.9561 35.9901 93.6934 40.9862 93.4424 45.7518C93.0986 52.2831 92.7783 58.3847 95.3281 65.8671C97.2227 71.4276 100.53 75.6932 105.696 78.1874C97.7842 85.7811 81.1592 86.7479 70.7861 87.3026V99.7538C76.5391 101.801 83.085 103.127 89.6074 104.449C94.2031 105.381 98.7861 106.308 103.072 107.486C89.8955 119.601 72.3115 127 53 127C33.9512 127 16.583 119.803 3.46777 107.978Z"
        fill="#0c0917"
      />
    </svg>
  );
});
